import { Get, Put, Post, Delete, Patch } from "./api.helper"
import { store } from "store"
import Config from "Config"
import { appendQueryParams } from "utils/urlUtils"
import toast from "react-hot-toast"
import { handleFetchError } from "utils/errorHandler"

// **** AUTH APIS
export const Login = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/auth/login",
      body: bodyData,
      isAuthorized: false,
      showToaster,
   })
}

export const GetMe = () => {
   return Get({ url: "/user" })
}

export const ForgotPassword = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/auth/forget-password",
      body: bodyData,
      showToaster,
   })
}
export const ChangePassword = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/user/change-password",
      body: bodyData,
      showToaster,
   })
}

export const ForgotPasswordVerification = (
   bodyData = {},
   showToaster = true
) => {
   return Post({
      url: "/auth/forget-password/verification",
      body: bodyData,
      showToaster,
   })
}

export const ResetPassword = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/auth/reset-password",
      body: bodyData,
      showToaster,
   })
}

export const CSVFileUpload = (bodyData = {}, showToaster = true) => {
   const token = store.getState().userAuth.user.Token
   return fetch(`${Config.env().API_URL}/item/bulk-items`, {
      headers: {
         Authorization: token,
      },
      body: bodyData,
      method: "POST",
   }).then(res => handleFetchError(res))
}

export const ResendOtpCode = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/auth/resend-otp",
      body: bodyData,
      showToaster,
   })
}

export const Logout = () => {
   return Post({
      url: "/user/logout",
   })
}

export const WarehouseInventoryListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/inventory/warehouse-inventory",
      params,
      abortSignal,
   })
}

// setting apis

export const NotificationSetting = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/user/notification_setting",
      body: bodyData,
      showToaster,
   })
}

export const passwordSetting = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/user/change-password",
      body: bodyData,
      showToaster,
   })
}

//Finance Dashboard

export const GetStockListing = (params = {}) => {
   return Get({
      url: "/inventory/dashboard-shortage",
      params,
   })
}

export const GetAdminFinanceScrapReturnListing = (
   params = {},
   abortSignal = null
) => {
   return Get({ url: "/requests/warehouse-scrap-return", params, abortSignal })
}
export const AdminFinanceDashboardAnalytics = () => {
   return Get({
      url: "/inventory/dashboard",
   })
}

export const ItemCategoryCategoriesListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/items-category/categories",
      params,
      abortSignal,
   })
}

export const GetDepartmentInventoryListing = (params = {}) => {
   return Get({ url: "/inventory/department-inventory", params })
}

export const GetDepartmentInventoryRequestListing = (
   params = {},
   abortSignal = null
) => {
   return Get({ url: "/inventory/department-requests", params, abortSignal })
}

export const GetBuildItemsListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/configurator-build/build-items", params, abortSignal })
}

export const AddDeparmentInventoryRequest = (
   bodyData = {},
   showToaster = true
) => {
   return Post({
      url: "/inventory/department-requests",
      body: bodyData,
      showToaster,
   })
}

export const AddWarehouseInventoryRequest = (
   bodyData = {},
   showToaster = true
) => {
   return Post({
      url: "/inventory/warehouse-requests",
      body: bodyData,
      showToaster,
   })
}

export const GetDepartmentsListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/department/departments", params, abortSignal })
}

export const GetDepartmentById = (id = "") => {
   return Get({ url: `/department/${id}` })
}

export const GetItemsListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/item/items", params, abortSignal })
}

export const GetItemDetailsById = (id = "") => {
   return Get({ url: `/item/${id}` })
}

export const GetWarehouseInventoryPODetails = (id = "") => {
   return Get({ url: `/inventory/items-purchase-orders/${id}` })
}

export const GetInventoryItemById = (id = "") => {
   return Get({ url: `/inventory/items-by-id/${id}` })
}

// **** FINANCE ORDER MANAGEMENT APIS
export const OrderRequestByItemsListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/inventory/finance-requests-by-items",
      params,
      abortSignal,
   })
}

export const OrderRequestByOrderListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/inventory/warehouse-requests",
      params,
      abortSignal,
   })
}

export const PlacedOrdersOMListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/inventory/purchase-orders",
      params,
      abortSignal,
   })
}

export const WarehouseRequestDetialViewById = id => {
   return Get({
      url: `/inventory/finance-requests-by-id/${id}`,
   })
}

export const InventoryItemsById = (id, params = {}, abortSignal = null) => {
   return Get({
      url: `/inventory/items-by-id/${id}`,
      params,
      abortSignal,
   })
}

export const VendorListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/vendor/vendors",
      params,
      abortSignal,
   })
}

export const VendorDetailsById = (params = {}, abortSignal = null, id) => {
   return Get({
      url: `/vendor/${id}`,
      params,
      abortSignal,
   })
}

export const VendorItemsDetailsById = (params = {}, abortSignal = null, id) => {
   return Get({
      url: `/vendor/vendor-items/${id}`,
      params,
      abortSignal,
   })
}

export const DeleteVendor = (id, abortSignal = null) => {
   return Delete({
      url: `/vendor/${id}`,
      abortSignal,
   })
}

export const CreateOrderFinance = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/inventory/finance-order",
      body: bodyData,
      showToaster,
   })
}

export const GetVendorById = (id = "") => {
   return Get({
      url: `/vendor/${id}`,
   })
}

export const CreateVendor = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/vendor",
      body: bodyData,
      showToaster,
   })
}

export const EditVendor = (bodyData, id, abortSignal = null) => {
   return Put({
      url: `/vendor/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const UserListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/user/listing",
      params,
      abortSignal,
   })
}

export const WarehouseListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/warehouse/listing",
      params,
      abortSignal,
   })
}

export const CreateUser = (bodyData = {}) => {
   return Post({
      url: "/user/user",
      body: bodyData,
   })
}

export const DepartmentListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/department/departments",
      params,
      abortSignal,
   })
}

export const GetUserListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/user/listing",
      params,
      abortSignal,
   })
}

export const AddWarehouse = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/warehouse/warehouse",
      body: bodyData,
      showToaster,
   })
}

export const EditUser = (bodyData = {}, id = "", abortSignal = null) => {
   return Put({
      url: `/user/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateWarehouse = (id, bodyData = {}, showToaster = true) => {
   return Put({
      url: `/warehouse/${id}`,
      body: bodyData,
      showToaster,
   })
}

export const AddDepartment = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/department",
      body: bodyData,
      showToaster,
   })
}

export const UpdateDepartment = (id, bodyData = {}, showToaster = true) => {
   return Put({
      url: `/department/${id}`,
      body: bodyData,
      showToaster,
   })
}

export const DeleteDepartment = (id, abortSignal = null) => {
   return Delete({
      url: `/department/${id}`,
      abortSignal,
   })
}

export const DeleteWarehouse = (id, abortSignal = null) => {
   return Delete({
      url: `/warehouse/${id}`,
      abortSignal,
   })
}

//  Media
export const uploadMediaInit = bodyData => {
   return Post({
      url: "/media/upload/init",
      body: bodyData,
   })
}

export const GetScrapReturnListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/requests/scrap-return", params, abortSignal })
}

export const CreateScrapReturnRequest = (bodyData = {}) => {
   return Post({
      url: "/requests/scrap-return",
      body: bodyData,
   })
}

export const uploadMediaFinalize = bodyData => {
   return Post({
      url: "/media/upload/finalize",
      body: bodyData,
   })
}

export const uploadMedia = (url, blob) => {
   return fetch(url, {
      body: blob,
      method: "PUT",
   })
      .then(res => {
         return Promise.resolve(res)
      })
      .catch(err => {
         return Promise.reject(err)
      })
}

export const GetScrapReturnRequestById = (id = "", params = {}) => {
   return Get({ url: `/requests/scrap-return/${id}`, params })
}

export const GetPullbackRequestListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/requests/pullback-listing", params, abortSignal })
}

export const DepartmentFulfillmentByWarehouse = (
   bodyData = {},
   showToaster = true
) => {
   return Post({
      url: "/inventory/department-request",
      body: bodyData,
      showToaster,
   })
}

export const GetPdfReport = (params = {}, abortSignal = null) => {
   const token = store.getState().userAuth.user.Token
   const url = appendQueryParams(`${Config.env().API_URL}/pdf/pdf`, params)

   return fetch(url, {
      headers: {
         Authorization: token,
         "Content-Type": " application/pdf",
      },
      responseType: "blob",
      method: "GET",
   })
      .then(res => Promise.resolve(res))
      .catch(err => {})
}

export const DeleteInventoryItem = (id, abortSignal = null) => {
   return Delete({
      url: `/item/${id}`,
      abortSignal,
   })
}

//  Item Catalog

export const GetItemCatalogListing = (params = {}, abortSignal = null) => {
   return Get({ url: "/item-catalog/items-catalog", params, abortSignal })
}

export const GetItemCatalogDetailsById = (
   params = {},
   abortSignal = null,
   id = ""
) => {
   return Get({ url: `/item-catalog/department-catelog-items/${id}`, params })
}

export const DeleteItemCatalog = (id, abortSignal = null) => {
   return Delete({
      url: `/item-catalog/${id}`,
      abortSignal,
   })
}

export const DeleteItemFromItemCatalog = (id, abortSignal = null) => {
   return Delete({
      url: `/item-catalog/delete-item/${id}`,
      abortSignal,
   })
}

export const UpdateItemCatalog = (id, bodyData = {}, showToaster = true) => {
   return Put({
      url: `/item-catalog/${id}`,
      body: bodyData,
      showToaster,
   })
}

export const AddItemCatalog = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/item-catalog",
      body: bodyData,
      showToaster,
   })
}
export const UpdateUserPassword = (id, bodyData = {}, showToaster = true) => {
   return Post({
      url: `/user/reset-password/${id}`,
      body: bodyData,
      showToaster,
   })
}
export const GetGlobalQuantityById = (id = "", params = {}) => {
   return Get({ url: `/inventory/items-global-quantities/${id}`, params })
}

export const ItemCategoriesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/items-category/categories",
      params,
      abortSignal,
   })
}

export const UpdateItemCategory = (id = "", bodyData = {}) => {
   return Put({
      url: `/items-category/${id}`,
      body: bodyData,
   })
}

export const AddItemCategory = (bodyData = {}) => {
   return Post({
      url: "/items-category",
      body: bodyData,
   })
}

export const AddNewItem = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/item",
      body: bodyData,
      showToaster,
   })
}

export const AddSelectedItem = (bodyData = {}, showToaster = true) => {
   return Post({
      url: "/item/synchronize-items",
      body: bodyData,
      showToaster,
   })
}

export const UpdateSelectedItem = (bodyData = {}, showToaster = true) => {
   return Put({
      url: "/item/bulk-items",
      body: bodyData,
      showToaster,
   })
}

export const UpdateItem = (id = "", bodyData = {}, showToaster = true) => {
   return Put({
      url: `/item/${id}`,
      body: bodyData,
      showToaster,
   })
}
export const GetNotifications = (params = {}, abortSignal = null) => {
   return Get({
      url: "/notification",
      params,
      abortSignal,
   })
}

export const MarkNotificationsAsRead = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/notification/read-notifications`,
      body: bodyData,
      abortSignal,
   })
}
// Inventory Settings
// Timer Configuration Apis
export const AddInventorySettings = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/inventory-settings`,
      body: bodyData,
      abortSignal,
   })
}

export const GetInventorySettings = (params = {}, abortSignal = null) => {
   return Get({
      url: "/inventory-settings/inventory-setting-type",
      params,
      abortSignal,
   })
}

export const GetInventorySettingsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/inventory-settings/settings",
      params,
      abortSignal,
   })
}

export const UpdateInventorySettings = (id = "", bodyData = {}) => {
   return Put({
      url: `/inventory-settings/${id}`,
      body: bodyData,
   })
}
export const GetProductionLinesMoulds = (params = "", abortSignal = null) => {
   return Get({
      url: `/production-mould/moulds`,
      params,
      abortSignal,
   })
}
export const SetProductionLineMould = bodyData => {
   return Post({
      url: `/production-mould`,
      body: bodyData,
   })
}
export const GetProductionLinesDailyConfigurations = (
   params = "",
   abortSignal = null
) => {
   return Get({
      url: `/daily-production-configuration/configurations`,
      params,
      abortSignal,
   })
}
export const UpdateProductionLinesDailyConfigurations = bodyData => {
   return Patch({
      url: `/daily-production-configuration`,
      body: bodyData,
   })
}

export const GetProductionLinesOverrides = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/production-override/overrides`,
      params,
      abortSignal,
   })
}

export const AddGetProductionLinesOverrides = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/production-override`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteProductionLinesOverrides = id => {
   return Delete({
      url: `/production-override/${id}`,
   })
}

export const UpdateProductionLinesOverrides = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/production-override/${id}`,
      body: bodyData,
      abortSignal,
   })
}
export const UpdateProductionLines = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Patch({
      url: `/production-line/${id}`,
      body: bodyData,
      abortSignal,
   })
}
export const GetPurchaseRequestsItems = (
   params = {},
   abortSignal = null,
   id = ""
) => {
   return Get({
      url: `/inventory/warehouse-requests-items/${id}`,
      params,
      abortSignal,
   })
}

export const GetWarehouseItemsReceiving = (
   params = {},
   abortSignal = null,
   id = ""
) => {
   return Get({
      url: `/inventory/warehouse-requests-items-receivings/${id}`,
      params,
      abortSignal,
   })
}
export const GetPurchaseOrdersItems = (
   params = {},
   abortSignal = null,
   id = ""
) => {
   return Get({
      url: `/inventory/purchase-orders-items/${id}`,
      params,
      abortSignal,
   })
}

export const CancelPOItem = (id = "", bodyData = {}) => {
   return Put({
      url: `/inventory/cancel-purchase-order-item/${id}`,
      body: bodyData,
   })
}

// Configurator Settings

// ==>  Trailers

export const GetTrailersListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-trailer/trailers",
      params,
      abortSignal,
   })
}

export const GetTrailersDetails = (id = "") => {
   return Get({
      url: `/configurator-trailer/${id}`,
   })
}

export const UpdateTrailer = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-trailer/${id}`,
      body: bodyData,
   })
}

export const CreateTrailer = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailer = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer/${id}`,
      abortSignal,
   })
}

// ==>  Build
export const GetBuildStationsListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-build/listing",
      params,
      abortSignal,
   })
}

export const GetBuildStationDetails = (id = "", bodyData = {}) => {
   return Get({
      url: `url/${id}`,
      body: bodyData,
   })
}

export const DeleteBuildStation = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-build/${id}`,
      abortSignal,
   })
}

export const CreateBuildStation = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-build`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateBuildStation = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-build/${id}`,
      body: bodyData,
   })
}

export const GetBuildStationItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/url`,
      params,
      abortSignal,
   })
}

export const GetBuildStationItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/url${id}`,
      params,
      abortSignal,
   })
}

// ==>  Base Features
export const GetBaseFeaturesCategoriesListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-base-features/listing",
      params,
      abortSignal,
   })
}

export const GetBaseFeatureCategoryDetails = (id = "", bodyData = {}) => {
   return Get({
      url: `/configurator-base-features/${id}`,
      body: bodyData,
   })
}

export const DeleteBaseFeatureCategory = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-base-features/category/${id}`,
      abortSignal,
   })
}

export const DeleteBaseFeatureCategoryItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-base-features/subtype/${id}`,
      abortSignal,
   })
}

export const CreateBaseFeatureCategory = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-base-features/category`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateBaseFeatureCategory = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-base-features/category/${id}`,
      body: bodyData,
   })
}

export const UpdateBaseFeatureCategorySequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-base-features/basefeature-sequence`,
      body: bodyData,
   })
}

export const GetBaseFeatureCategoryItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-base-features/subTypes`,
      params,
      abortSignal,
   })
}

export const GetBaseFeatureCategoryItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-base-features/subType/${id}`,
      params,
      abortSignal,
   })
}

export const AddBaseFeatureCategoryItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-base-features/subtype`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateBaseFeatureCategoryItems = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-base-features/subtype/${id}`,
      body: bodyData,
   })
}

// ==> Warranty
export const UpdateWarrantyListingSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-warranty/warranty-sequence`,
      body: bodyData,
   })
}
export const GetWarrantyListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-warranty/warranties",
      params,
      abortSignal,
   })
}
export const CreateWarranty = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-warranty`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteWarranty = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-warranty/${id}`,
      abortSignal,
   })
}

export const GetWarrantyDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-warranty/${id}`,
      params,
      abortSignal,
   })
}
export const GetNextAvailableSlot = (params = {}) => {
   return Get({
      url: `/timeline/order-estimated-dates`,
      params,
   })
}

export const UpdateWarranty = (id = "", bodyData = {}) => {
   return Patch({
      url: `/configurator-warranty/${id}`,
      body: bodyData,
   })
}

// ==>  Packages

export const GetPackagesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-package/packages",
      params,
      abortSignal,
   })
}
export const GetPackageDetails = (id = "", params = {}, abortSignal = null) => {
   return Get({
      url: `/configurator-package/${id}`,
      params,
      abortSignal,
   })
}

export const CreatePackage = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-package`,
      body: bodyData,
      abortSignal,
   })
}
export const UpdatePackage = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-package/${id}`,
      body: bodyData,
   })
}
export const DeletePackage = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-package/${id}`,
      abortSignal,
   })
}

export const GetPackageItemsListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-package/package-items",
      params,
      abortSignal,
   })
}
export const GetPackageItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-package/package-item/${id}`,
      params,
      abortSignal,
   })
}

export const CreatePackageItem = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-package/package-item`,
      body: bodyData,
      abortSignal,
   })
}
export const UpdatePackageItem = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-package/package-item/${id}`,
      body: bodyData,
   })
}
export const DeletePackageItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-package/package-item/${id}`,
      abortSignal,
   })
}

export const GetConfiguratorBuildItems = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-build/trailer/build-items",
      params,
      abortSignal,
   })
}

// ==>  Equipment

export const GetEquipmentsCategoryItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-equipment/subTypes`,
      params,
      abortSignal,
   })
}

export const GetEquipmentsCategoryListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-equipment/equipments",
      params,
      abortSignal,
   })
}

export const GetEquipmentCategoryDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-equipment/${id}`,
      params,
      abortSignal,
   })
}

export const DeleteEquipment = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-equipment/category/${id}`,
      abortSignal,
   })
}
export const DeleteEquipmentCategoryItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-equipment/subtype/${id}`,
      abortSignal,
   })
}
export const UpdateEquipment = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-equipment/${id}`,
      body: bodyData,
   })
}

export const CreateEquipmentCategory = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-equipment/category`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateEquipmentCategory = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-equipment/category/${id}`,
      body: bodyData,
   })
}

export const AddEquipmentCategoryItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-equipment/subType`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateEquipmentCategoryItems = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-equipment/subType/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const GetEquipmentCategoryItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-equipment/subType/${id}`,
      params,
      abortSignal,
   })
}

// ==>  Summary
export const GetSummariesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/summary/summaries",
      params,
      abortSignal,
   })
}

export const GetSummaryDetails = (id = "", params = {}, abortSignal = null) => {
   return Get({
      url: `/summary/${id}`,
      params,
      abortSignal,
   })
}

export const DeleteSummary = (id, abortSignal = null) => {
   return Delete({
      url: `/summary/${id}`,
      abortSignal,
   })
}
export const UpdateSummary = (id = "", bodyData = {}) => {
   return Put({
      url: `/summary/${id}`,
      body: bodyData,
   })
}

export const CreateSummary = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/summary`,
      body: bodyData,
      abortSignal,
   })
}

// Customization

export const GetCustomizationCategoryItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-customization/subTypes`,
      params,
      abortSignal,
   })
}

export const GetCustomizationCategoryListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-customization/customizations",
      params,
      abortSignal,
   })
}

export const GetCustomizationCategoryDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-customization/${id}`,
      params,
      abortSignal,
   })
}

export const DeleteCustomizationCategory = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-customization/category/${id}`,
      abortSignal,
   })
}

export const DeleteCustomizationCategoryItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-customization/subtype/${id}`,
      abortSignal,
   })
}

export const UpdateCustomizationCategory = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-customization/category/${id}`,
      body: bodyData,
   })
}

export const UpdateGlobalCustomizationSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-customization/update-sequence`,
      body: bodyData,
   })
}

export const UpdateGlobalCustomizationPropertySequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-customization/subType-sequence`,
      body: bodyData,
   })
}

export const CreateCustomizationCategory = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-customization/category`,
      body: bodyData,
      abortSignal,
   })
}

export const AddCustomizationCategoryItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-customization/subType`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateCustomizationCategoryItems = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-customization/subType/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const GetCustomizationCategoryItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-customization/subType/${id}`,
      params,
      abortSignal,
   })
}

// Clone Configurator Trailer
export const CloneConfiguratorTrailer = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer/clone-trailer`,
      body: bodyData,
      abortSignal,
   })
}

//  Trailer Orders

export const GetOrderedTrailersListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/configurator-order/orders`,
      params,
      abortSignal,
   })
}
export const GetOrderedTrailersDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-order/orders/${id}`,
      params,
      abortSignal,
   })
}
export const UpdateOrderedTrailer = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-order/orders/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const GetConfiguratorOrderPdf = async ({
   bodyData = {},
   abortSignal = null,
}) => {
   const token = store.getState().userAuth.user.Token
   const url = `${
      Config.env().API_URL
   }/configurator-order/export-configurator-pdf`

   return fetch(url, {
      method: "POST",
      headers: {
         Authorization: token,
         "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
      signal: abortSignal,
   })
      .then(res => {
         if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`)
         }
         return res
      })
      .catch(err => {
         throw err
      })
}

// Trailer Management
export const GeTrailersTypesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/trailer-managment`,
      params,
      abortSignal,
   })
}

export const AddTrailerType = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/trailer-managment`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerType = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/trailer-managment/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerType = (id, abortSignal = null) => {
   return Delete({
      url: `/trailer-managment/${id}`,
      abortSignal,
   })
}

export const GetTrailerTypeDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/trailer-managment/${id}`,
      params,
      abortSignal,
   })
}

export const DirectPOTransfer = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/inventory/generate-warehouse-order`,
      body: bodyData,
      abortSignal,
   })
}

// Production Line

export const GetOverrides = (params = {}, abortSignal = null) => {
   return Get({
      url: `/overrides/overrides`,
   })
}
export const AddOverrides = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/overrides`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateOverrides = (id = "", bodyData = {}, abortSignal = null) => {
   return Put({
      url: `/overrides/${id}`,
      body: bodyData,
      abortSignal,
   })
}
export const DeleteOverride = (id, abortSignal = null) => {
   return Delete({
      url: `/overrides/${id}`,
      abortSignal,
   })
}
export const GetOverridesDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/overrides/override/${id}`,
   })
}

//Production Line
export const GetProductionLinesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/production-line/production-lines`,
      params,
      abortSignal,
   })
}

export const GetProductionLinesEstimationListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/timeline/all-production-lines-estimation`,
      params,
      abortSignal,
   })
}

export const GetProductionLineAvailableSlots = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/timeline/available-slots`,
      params,
      abortSignal,
   })
}

export const GetProductionLineDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/production-line/${id}`,
      params,
      abortSignal,
   })
}

export const DeleteProductionLine = (id, abortSignal = null) => {
   return Delete({
      url: `/production-line/${id}`,
      abortSignal,
   })
}

export const UpdateProductionLine = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Patch({
      url: `/production-line/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const AddProductionLine = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/production-line`,
      body: bodyData,
      abortSignal,
   })
}

// Creates a new line from an existing one, carrying over its stages, stations, moulds and
// weekday slot configuration. Only the fields that cannot be shared between two lines are
// sent: name, startingSlotId, startDate, endDate.
export const CloneProductionLine = (id = "", bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/production-line/${id}/clone`,
      body: bodyData,
      abortSignal,
   })
}

export const AddProductionMould = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/production-mould`,
      body: bodyData,
      abortSignal,
   })
}

export const GetProductionMouldListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/production-mould/moulds`,
   })
}

export const GetProductionMouldDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/production-mould/${id}`,
      params,
      abortSignal,
   })
}

export const GetProductionStagesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/production-line-stages/stages`,
      params,
      abortSignal,
   })
}

export const AddProductionStages = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/production-line-stages/stages`,
      body: bodyData,
      abortSignal,
   })
}

export const GetProductionStagesDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/production-line-stages/${id}`,
      params,
      abortSignal,
   })
}

//Timeline

export const GetTimelineListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `timmeline/timeline`,
   })
}
export const AddTrailerOrder = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/timeline/add-order-at-slot`,
      body: bodyData,
      abortSignal,
   })
}
// Countsheets

export const CountsheetItemDetails = (params = {}, abortSignal = null) => {
   return Get({
      url: `/department/item-audit-history`,
      params,
      abortSignal,
   })
}

//Audit Commits Warehouse
export const CommitWarehouseAuditItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/warehouse/commit-audit-items`,
      body: bodyData,
      abortSignal,
   })
}
export const GetBulkCommitAuditItemsSummary = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/warehouse/bulk-commit-audit-items-summary`,
      body: bodyData,
      abortSignal,
   })
}
//Audit Commits Departments
export const CommitDepartmentAuditItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/department/commit-audit-items`,
      body: bodyData,
      abortSignal,
   })
}
export const GetDepartmentBulkCommitAuditItemsSummary = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/department/bulk-commit-audit-items-summary`,
      body: bodyData,
      abortSignal,
   })
}

export const CountsheetListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/department/audit-items`,
      params,
      abortSignal,
   })
}

export const CreateItemAudit = (bodyData = {}) => {
   return Post({
      url: "/department/audit-item",
      body: bodyData,
   })
}
// Time Line
export const ExportTimelineGeneratePdf = async (
   params = {},
   abortSignal = null
) => {
   const token = store.getState().userAuth.user.Token
   const url = `${
      Config.env().API_URL
   }/timeline/generate-pdf?productionLineId=${
      params.productionLineId
   }&startDate=${params.startDate}`

   return fetch(url, {
      method: "GET",
      headers: {
         Authorization: token,
         "Content-Type": "application/json",
      },
      signal: abortSignal,
   })
      .then(res => {
         if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`)
         }
         return res
      })
      .catch(err => {
         throw err
      })
}

export const GetCustomerListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/timeline/customers`,
      params,
      abortSignal,
   })
}
export const GetTimelineOrderListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/timeline/timeline-orders`,
      params,
      abortSignal,
   })
}

export const GetTimeLineListing = (params = {}, abortSignal = null) => {
   return Get({
      url: `/timeline/timeline`,
      params,
      abortSignal,
   })
}

export const GetInventoryWarning = (params = {}, abortSignal = null) => {
   return Get({
      url: `/timeline/inventory-warning`,
      params,
      abortSignal,
   })
}

export const AddTimeLineNote = (bodyData = {}, abortSignal) => {
   return Post({
      url: `/timeline/note`,
      body: bodyData,
      abortSignal,
   })
}
export const UpdateTimeLineOrder = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Patch({
      url: `/timeline/timeline-orders/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTimeLineNote = (id = "", bodyData = {}) => {
   return Patch({
      url: `/timeline/note/${id}`,
      body: bodyData,
   })
}

export const GetDetailedInventoryPrediction = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/timeline/detailed-inventory-prediction`,
      params,
      abortSignal,
   })
}

export const UseInventory = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/timeline/use-inventory`,
      body: bodyData,
      abortSignal,
   })
}

export const MigrateTimelineOrders = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/timeline/migrate-orders-estimation`,
      body: bodyData,
      abortSignal,
   })
}

export const MigrateOrders = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/timeline/migrate-orders`,
      body: bodyData,
      abortSignal,
   })
}

// Individual Trailer Configurator ==> Trailer Base Features

export const GetTrailerBaseFeaturesCategoriesListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-trailer-base-features/listing",
      params,
      abortSignal,
   })
}

export const GetTrailerBaseFeatureCategoryDetails = (
   id = "",
   bodyData = {}
) => {
   return Get({
      url: `/configurator-trailer-base-features/${id}`,
      body: bodyData,
   })
}

export const DeleteTrailerBaseFeatureCategory = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-base-features/category/${id}`,
      abortSignal,
   })
}

export const DeleteTrailerBaseFeatureCategoryItem = (
   id,
   abortSignal = null
) => {
   return Delete({
      url: `/configurator-trailer-base-features/subtype/${id}`,
      abortSignal,
   })
}

export const CreateTrailerBaseFeatureCategory = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-trailer-base-features/category`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerBaseFeatureCategory = (id = "", bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-base-features/category/${id}`,
      body: bodyData,
   })
}

export const UpdateTrailerBaseFeatureCategorySequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-base-features/basefeature-sequence`,
      body: bodyData,
   })
}

// Reorders the GLOBAL base-feature catalog. The new order propagates to every trailer that is not
// order-customized.
export const UpdateGlobalBaseFeatureSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-base-features/basefeature-sequence`,
      body: bodyData,
   })
}

// Reorders the options inside one GLOBAL base feature. Propagates to every non-customized trailer.
export const UpdateGlobalBaseFeatureSubTypeSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-base-features/subtype-sequence`,
      body: bodyData,
   })
}

// Toggles whether a trailer follows the global order or keeps its own. Turning it off resets the
// trailer's order to the global one, so the UI confirms first.
export const SetTrailerOrderCustomized = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-base-features/order-customized`,
      body: bodyData,
   })
}

// Reorders the options within a single base feature category (e.g. the choices under Exterior)
export const UpdateTrailerBaseFeatureSubTypeSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-base-features/subtype-sequence`,
      body: bodyData,
   })
}

export const GetTrailerBaseFeatureCategoryItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-base-features/subTypes`,
      params,
      abortSignal,
   })
}

export const GetTrailerBaseFeatureCategoryItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-base-features/subType/${id}`,
      params,
      abortSignal,
   })
}

export const AddTrailerBaseFeatureCategoryItems = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-trailer-base-features/subtype`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerBaseFeatureCategoryItems = (
   id = "",
   bodyData = {}
) => {
   return Put({
      url: `/configurator-trailer-base-features/subtype/${id}`,
      body: bodyData,
   })
}

// Individual Trailer Configurator ==> Customization / Personalization

export const GetTrailerCustomizationSubTypesListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-trailer-customization/subTypes",
      params,
      abortSignal,
   })
}

export const UpdateTrailerCustomizationSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-customization/update-sequence`,
      body: bodyData,
   })
}

// Reorders the options within a single personalization category
export const UpdateTrailerCustomizationPropertySequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-customization/property-sequence`,
      body: bodyData,
   })
}

export const GetTrailerCustomizationsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-trailer-customization/customizations",
      params,
      abortSignal,
   })
}

export const GetTrailerCustomizationCategoryDetails = (
   categoryId = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-customization/${categoryId}`,
      params,
      abortSignal,
   })
}

export const GetTrailerCustomizationSubTypeDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-customization/subType/${id}`,
      params,
      abortSignal,
   })
}

export const UpdateTrailerCustomizationSubType = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-customization/subType/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerCustomizationSubType = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-customization/subtype/${id}`,
      abortSignal,
   })
}

export const UpdateTrailerCustomizationCategory = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-customization/category/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const CreateTrailerCustomizationSubType = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-trailer-customization/subType`,
      body: bodyData,
      abortSignal,
   })
}

// Individual Trailer Configurator ==> Packages

export const GetTrailerPackagesListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-trailer-packages/packages",
      params,
      abortSignal,
   })
}

// Reorders the GLOBAL package catalog. Propagates to every non-customized trailer.
export const UpdateGlobalPackageSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-package/update-sequence`,
      body: bodyData,
   })
}

// Reorders the items inside one GLOBAL package. Propagates to every non-customized trailer.
export const UpdateGlobalPackageItemSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-package/item-sequence`,
      body: bodyData,
   })
}

export const UpdateTrailerPackageSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-packages/update-sequence`,
      body: bodyData,
   })
}

// Reorders the items within a single package
export const UpdateTrailerPackageItemSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-packages/item-sequence`,
      body: bodyData,
   })
}

export const GetTrailerPackageDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-packages/${id}`,
      params,
      abortSignal,
   })
}

export const CreateTrailerPackage = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer-packages`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerPackage = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-packages/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerPackage = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-packages/${id}`,
      abortSignal,
   })
}

export const GetTrailerPackageItemsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-trailer-packages/package-items",
      params,
      abortSignal,
   })
}

export const GetTrailerPackageItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-packages/package-item/${id}`,
      params,
      abortSignal,
   })
}

export const CreateTrailerPackageItem = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer-packages/package-item`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerPackageItem = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-packages/package-item/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerPackageItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-packages/package-item/${id}`,
      abortSignal,
   })
}

// Individual Trailer Configurator ==> Equipment

export const GetTrailerEquipmentsListing = (
   params = {},
   abortSignal = null
) => {
   return Get({
      url: "/configurator-trailer-equipment/equipment",
      params,
      abortSignal,
   })
}

// Reorders the GLOBAL equipment catalog. Propagates to every non-customized trailer.
export const UpdateGlobalEquipmentSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-equipment/update-sequence`,
      body: bodyData,
   })
}

export const UpdateTrailerEquipmentSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-equipment/update-sequence`,
      body: bodyData,
   })
}

export const GetTrailerEquipmentDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-equipment/${id}`,
      params,
      abortSignal,
   })
}

export const CreateTrailerEquipment = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer-equipment`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerEquipment = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-equipment/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerEquipment = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-equipment/${id}`,
      abortSignal,
   })
}

export const GetTrailerEquipmentItems = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-trailer-equipment/equipment-properties",
      params,
      abortSignal,
   })
}

export const GetTrailerEquipmentItemDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-equipment/equipment-property/${id}`,
      params,
      abortSignal,
   })
}

export const CreateTrailerEquipmentItem = (
   bodyData = {},
   abortSignal = null
) => {
   return Post({
      url: `/configurator-trailer-equipment/equipment-property`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerEquipmentItem = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Put({
      url: `/configurator-trailer-equipment/equipment-property/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerEquipmentItem = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-equipment/equipment-property/${id}`,
      abortSignal,
   })
}

// Individual Trailer Configurator ==> Warranty

export const UpdateTrailerWarrantyListingSequence = (bodyData = {}) => {
   return Put({
      url: `/configurator-trailer-warranty/warranty-sequence`,
      body: bodyData,
   })
}

export const GetTrailerWarrantyListing = (params = {}, abortSignal = null) => {
   return Get({
      url: "/configurator-trailer-warranty/warranties",
      params,
      abortSignal,
   })
}

export const GetTrailerWarrantyDetails = (
   id = "",
   params = {},
   abortSignal = null
) => {
   return Get({
      url: `/configurator-trailer-warranty/${id}`,
      params,
      abortSignal,
   })
}

export const CreateTrailerWarranty = (bodyData = {}, abortSignal = null) => {
   return Post({
      url: `/configurator-trailer-warranty`,
      body: bodyData,
      abortSignal,
   })
}

export const UpdateTrailerWarranty = (
   id = "",
   bodyData = {},
   abortSignal = null
) => {
   return Patch({
      url: `/configurator-trailer-warranty/${id}`,
      body: bodyData,
      abortSignal,
   })
}

export const DeleteTrailerWarranty = (id, abortSignal = null) => {
   return Delete({
      url: `/configurator-trailer-warranty/${id}`,
      abortSignal,
   })
}
